import { render } from "./LayoutAuthentication.vue?vue&type=template&id=1219865a&scoped=true"
import script from "./LayoutAuthentication.vue?vue&type=script&lang=ts"
export * from "./LayoutAuthentication.vue?vue&type=script&lang=ts"

import "./LayoutAuthentication.vue?vue&type=style&index=0&id=1219865a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1219865a"

export default script